import { SidebarNav } from './SidebarNav';
import { SidebarFooter } from './SidebarFooter';
import styles from './Sidebar.module.css';

export function Sidebar() {
  return (
    <aside id="sidebar" className={styles.sidebar} aria-label="Main navigation">
      <SidebarNav />
      <SidebarFooter />
    </aside>
  );
}
